import { type Control, useWatch } from "react-hook-form";
import type { FilterFormValues } from "web_myplann/Portfolio/Components/Redesign/Filter/filterFormSchema";
import { normalizePortfolioFilter } from "web_myplann/Portfolio/Helpers/normalizePortfolioFilter";
import { useAvailableCategoriesByContractState } from "web_myplann/Portfolio/Hooks/useAvailableCategoriesByContractState";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

type FilterFormCategories = {
	availableCategories: PortfolioCategoryId[];
	categories: PortfolioCategoryId[];
};

export const useFilterFormCategories = (
	control: Control<FilterFormValues>,
): FilterFormCategories => {
	const availableByContractState = useAvailableCategoriesByContractState();
	const [contractState, categories] = useWatch({
		control,
		name: ["contractState", "categories"],
	});
	const shown = normalizePortfolioFilter(
		{ contractState, categories },
		availableByContractState,
	);

	return {
		availableCategories: availableByContractState?.[shown.contractState] ?? [],
		categories: shown.categories,
	};
};
